import apiClient from "../../services/apiClient";

// 문법뱅크. 지금 DB 에 쌓인 문항으로 문제지를 뽑는다. 모델을 부르지 않으므로 API 키도
// 비용도 들지 않는다.

// 소분류 트리와 보유 문항 수. 출제기와 같은 자료를 쓴다.
export async function fetchGrammarBankTreeAPI() {
  const response = await apiClient.get("/api/v1/echo/admin/grammar/skills", {
    withAuth: true,
  });
  return response.data;
}

// 문제지 한 장을 뽑는다. 같은 조건에 같은 seed 면 같은 문제지가 나온다.
export async function composeGrammarPaperAPI(options) {
  const response = await apiClient.post(
    "/api/v1/echo/admin/grammar/compose",
    options,
    { withAuth: true }
  );
  return response.data;
}

// 문제지·답지·해설지를 PDF 파일로 받는다. **조판은 서버가 한다.**
//
// 문항 목록을 보내지 않는다. 같은 조건과 같은 seed 면 서버가 같은 문제지를 다시 뽑으므로
// 화면은 조건만 보내면 되고, 그래야 화면에서 본 종이와 파일이 어긋나지 않는다.
export async function downloadGrammarPaperPdfAPI(options) {
  const response = await apiClient.post(
    "/api/v1/echo/admin/grammar/paper.pdf",
    options,
    { withAuth: true, responseType: "blob" }
  );

  // 파일 이름은 서버가 Content-Disposition 에 넣어 준다(한글이라 RFC 5987 형식).
  const disposition = response.headers["content-disposition"] || "";
  const matched = /filename\*=UTF-8''([^;]+)/.exec(disposition);
  const fileName = matched ? decodeURIComponent(matched[1]) : "문제지.pdf";

  const url = window.URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.click();
  window.URL.revokeObjectURL(url);
  return fileName;
}

// 저장해 둔 문제지 목록. 모사이트의 '내 자료' 자리다.
export async function fetchGrammarPaperListAPI() {
  const response = await apiClient.get("/api/v1/echo/admin/grammar/papers", {
    withAuth: true,
  });
  return response.data;
}

// 문제지 저장. id 를 함께 보내면 그 문서를 고친다.
export async function saveGrammarPaperAPI(payload) {
  const response = await apiClient.post(
    "/api/v1/echo/admin/grammar/papers",
    payload,
    { withAuth: true }
  );
  return response.data;
}

// 문제지 삭제.
export async function deleteGrammarPaperAPI(paperId) {
  const response = await apiClient.delete(
    `/api/v1/echo/admin/grammar/papers?id=${paperId}`,
    { withAuth: true }
  );
  return response.data;
}
